import i18next from "i18next";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Navbar } from "../../Components/Navbar/Navbar";
import "./PublicOffer.style.css";
import { Meta } from "../../Components/Helpers/Meta";
import { CgChevronDown } from "react-icons/cg";
import { useParams, Link } from "react-router-dom";
import InvestorSidebar from "../../Components/InvestorSidebar/InvestorSidebar";
import { LuDownload } from "react-icons/lu";

const NewPublicOfferInfo = () => {
  const { t } = useTranslation();
  const language = i18next.language;
  const { lang } = useParams();


  // useEffect(() => {
  //   if (lang) {
  //       i18next.changeLanguage(lang);
  //   }
  //   const updateTitle = () => {
  //       document.title = `${t("initial-public-offering")} - Cevher`;
  //     };

  //     updateTitle();

  //     const handleLanguageChanged = () => {
  //       updateTitle();
  //     };

  //     i18next.on("languageChanged", handleLanguageChanged);

  //     return () => {
  //       i18next.off("languageChanged", handleLanguageChanged);
  //     };
  //   }, [lang]);

  const [openIR, setOpenIR] = useState(true);
  const [openShare, setOpenShare] = useState(true);
  const [openIPO, setOpenIPO] = useState(true);


  // const docs = [
  //   { label: t("draft-prospectus"), href: "https://www.cevher.com/static/docs/Cevher-Jant-taslak-izahname.pdf" },
  //   { label: t("investment-fund-utilization-report"), href: "https://www.cevher.com/static/docs/fon-kullanim-yeri-raporu.pdf" },
  // ];

  const docs = [
    { label: t("spk-prospectus"), href: "https://www.cevher.com/static/docs/Cevher-Jant-taslak-izahname.pdf" },
    { label: t("prospectus-appendix-1-articles-of-association"), href: "https://www.cevher.com/static/docs/izahname-ek1-sirket-esas-sozlesmesi.pdf" },
    { label: t("prospectus-appendix-2-board-of-directors-internal-directive"), href: "https://www.cevher.com/static/docs/izahname-ek2-yk-ic-yonerge.pdf" },
    { label: t("prospectus-appendix-3-general-assembly-working-principles-and-procedures-internal-directive"), href: "https://www.cevher.com/static/docs/izahname-ek3-genel-kurul-ic-yonerge.pdf" },
    { label: t("prospectus-appendix-4-special-independent-audit-report-and-statement-of-responsibility"), href: "https://www.cevher.com/static/docs/izahname-ek4-ozel-bagimsiz-denetim-raporu.pdf" },
    { label: t("prospectus-appendix-5-legal-opinion-and-legal-counsel-statement-of-responsibility"), href: "https://www.cevher.com/static/docs/izahname-ek5-hukukcu-raporu.pdf" },
    { label: t("sale-announcement-to-savers"), href: "https://www.cevher.com/static/docs/tasarruf-sahiplerine-satis-duyurusu.pdf" },
    { label: t("price-determination-report"), href: "https://www.cevher.com/static/docs/fiyat-tespit-raporu.pdf" },
    { label: t("investment-fund-utilization-report"), href: "https://www.cevher.com/static/docs/fon-kullanim-yeri-raporu.pdf" },
    { label: t("participation-finance-principles-information-form"), href: "https://www.cevher.com/static/docs/katilim-finans-bilgi-formu.pdf" },
    { label: t("pwc-consulting-services-sector-report-and-statement-of-responsibility"), href: "https://www.cevher.com/static/docs/pwc-sektor-raporu.pdf" }
  ];

  return (
    <div>
      <Meta
        title={t("initial-public-offering")}
        description={t("initial-public-offering")}
        lang={lang}
      />
      <Navbar />

      {/* --- VAR OLAN HERO/BANNER BLOĞUN AYNEN DURUYOR --- */}
      <div className="c-wrapper">
        <div className="c-hero">
          <div className="c-hero-background">
            <picture>
              <img
                className="c-hero-image"
                alt=""
                src={require("../../assets/hero/public-offering.jpg")}
                style={{ width: "100%" }}
              />
            </picture>
          </div>
          <div className="c-hero-body">
            <div className="c-about-caption">
              <div
                className="c-caption-section"
                style={{ color: "#000000", textAlign: "center" }}
              >
                {t("investor-relations")}
              </div>
              <h1 className="c-caption-header" style={{ color: "#000000" }}>
                {t("initial-public-offering")}
              </h1>
            </div>
          </div>
        </div>

        {/* --- SADECE İÇERİK: Sidebar + Doküman listesi --- */}
        <div className="po-container">
          <InvestorSidebar />

          <main className="po-content">
            <div className="po-card">
              <ul className="po-docs">
                {docs.map((d, i) => (
                  <li key={i} className="po-doc-row">
                    <span className="po-doc-title">{d.label}</span>
                    <a
                      href={d.href}
                      target="_blank"
                      rel="noreferrer"
                      aria-label="Download"
                      className="po-doc-dl"
                    >
                      <LuDownload size={20} />
                    </a>
                  </li>

                ))}
              </ul>
            </div>
          </main>
        </div>
      </div>
    </div>
  );
};

export default NewPublicOfferInfo;